export default {
  route: {
    dashboard: '首页',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    rolePermission: '角色权限',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    Table: 'Table',
    dynamicTable: '动态 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 内编辑',
    complexTable: '综合 Table',
    tab: 'Tab',
    form: '表单',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    profile: '个人中心',

    translationmanager: '翻译管理',
    commoditymanager: '商品管理',
    ordermanager: '订单管理',
    inboundscanning: '入库扫描',
    systemmanager: '系统管理',
    platformconfiguration: '店铺配置',
    storedetail: '店铺详情',
    memberlist: '成员列表',
    rolemanager: '角色管理',
    warehousemanager: '仓库管理',
    putinwarehouse: '入库',
    putoutwarehouse: '出库',
    putoutwarehouseold: '出库（旧）',
    csmanager: '客户管理',
    platformorder: '平台订单',
    agentorder: '代发订单',
    dictmanager: '字典管理',
    hscode: '海关编码',
    translation: '翻译',
    singleton: '单件代发',
    helptobuy: '代买订单',
    syssetting: '系统设置',
    inven: '库存订单',
    statementmanager: '结算管理',
    orderlist: '订单列表',
    statementlist: '结算列表',
    billlist: '账单列表',
    balancelist: '交易明细',
    inventorymanager: '库存管理',
    inventoryrecord: '库存记录',
    inventorylist: '库存列表',
    inventoryaudit: '库存审核',
    goodscates: '商品类别',
    fee: '报价模板',
    price: '价格配置',
    balancedetail: '余额明细',
    cslist: '客户列表',
    agentlist: '代理列表',
    goodsdetail: '商品详情',
    uploadrecord: '上传记录',
    agentorderdetail: '订单详情',
    collectlist: '采集列表',
    datamanager: '数据管理',
    orderdata: '订单数据'
  },
  main: {
    updatepwd: '修改密码',
    logout: '退出登录',
    balance: '余额',
    cname: '客户姓名',
    ordercount: '发货总数',
    lastorderdate: '最后发货日期',
    customcount: '客户数量',
    copyurl: '复制推广链接',
    balance: '账户余额',
    tatolcz: '累计充值',
    morder: '本月发货'
  },
  member: {
    role: '角色',
    number: '编号',
    username: '用户名',
    phone: '手机号',
    ban: '封禁',
    unban: '解封',
    normal: '正常',
    addmember: '添加成员',
    updatememer: '编辑成员',
    realname: '姓名',
    password: '密码'
  },
  custom: {
    name: '姓名',
    phone: '手机号',
    ban: '封禁',
    unban: '解封',
    add: '添加客户',
    update: '编辑客户',
    password: '密码',
    country: '国家',
    balance: '余额',
    consume: '消费',
    recharge: '充值',
    refund: '退款',
    adminid: '创建者',
    search: '输入客户姓名或者手机号搜索',
    currbalance: '当前余额',
    rechargeamount: '充值余额',
    authorizationcode: '授权码',
    com: '公司',
    sendcount: '累计发货',
    cuscount: '推广客户数',
    sy: '累计收益'
  },
  agent: {
    search: '输入快递单号搜索',
    downloadxls: '下载制式表格',
    date: '日期',
    customername: '客户姓名',
    couriernumber: '快递单号',
    kcnumber: '库存数量',
    parcelnumber: '代发数量',
    goodsnumber: '商品总数',
    orderamount: '订单金额',
    allprint: '全部打印',
    address: '地址',
    phone: '电话',
    name: '姓名',
    danhao: '快递单号',
    danhaoko: '韩国快递单号',
    gname: '商品名',
    count: '数量',
    idcard: '通关号',
    create: '创建订单',
    edit: '编辑订单',
    postcode: '邮编',
    goodsnamezh: '中文品名',
    goodsnameen: '英文品名',
    price: '价格',
    priced: '美元价格',
    sendremark: '配送备注',
    unit: '单位',
    material: '材质',
    customer: '客户',
    weight: '重量',
    download: '下载',
    count_in: '存入库存',
    count_out: '取出库存',
    count_send: '包裹数量',
    count_pkg: '快递数量',
    moresearch: '更多搜索',
    oldlist: '上传记录',
    inputgn: '输入商品名搜索',
    inputr: '输入收件人信息搜索',
    onlym: '只看合单',
    remote: '偏远地区'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '领 头 鹿',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！',
    captacaa: '请按住滑块 拖动到右边',
    captacab: '验证通过',
    autologin: '一周内自动登录',
    forgotpwd: '忘记密码',
    forgotpwdlabel: '重 置 密 码',
    resetpwd: '重置密码',
    pinputphone: '请输入电话号码',
    getcode: '获取验证码',
    backlogin: '返回登陆',
    register: '注册会员',
    registerlabel: '注 册 会 员',
    pinputname: '请输入姓名',
    pinputcode: '请输入验证码',
    regis: '注册',
    s: '后重新获取',
    success: '注册成功！',
    suca: '初始密码为手机号后6位，',
    sucb: '请返回登录！',
    sucd: '重置密码成功！',
    xts: '系统提示',
    hts: '请完成滑动验证',
    ta: '哎呀 出错了 点击',
    tb: '刷新',
    tc: '重新再来一次',
    td: '重新载入'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  status: {
    all: '全部',
    checked: '已校验',
    uncheck: '未校验',
    waitcheck: '待校验',
    waitprint: '待打印',
    outwed: '已出库',
    inwed: '已入库',
    printed: '已打印',
    checking: '校验中',
    waitoutw: '待出库',
    waitinw: '待入库',
    inwing: '入库中',
    outwing: '出库中',
    waitsettle: '待结算',
    finish: '已完成'
  },
  table: {
    empty: '暂无数据',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '备注',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '日期',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    createtime: '创建时间',
    updatetime: '更新时间',
    status: '状态',
    print: '打印',
    show: '查看',
    amount: '金额',
    check: '校验',
    remark_order: '卖家备注栏',
    volume: '体积',
    audit: '审核',
    invalid: '作废',
    addmore: '补货',
    record: '记录'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  lan: {
    zh: '中国',
    ko: '韩国',
    en: '英国',
    ja: '日本'
  },
  common: {
    upload: '批量上传',
    langSelect: '切换语言成功',
    actionSuccess: '操作成功',
    pwdinit: '初始密码为手机号后6位',
    inputsearch: '输入搜索',
    noimg: '没有商品图片',
    rmb: '人民币',
    krw: '韩币',
    time: '时间'
  },
  input: {
    name: '请输入姓名',
    phone: '请输入电话',
    address: '请输入地址',
    idcard: '请输入通关号',
    postcode: '请输入邮编',
    danhao: '请输入快递单号',
    gnamecn: '请输入中文品名',
    gnameen: '请输入英文品名',
    price: '请输入价格',
    remark: '请输入备注',
    material: '请输入材质',
    gname: '请输入商品名',
    count: '请输入数量',
    spec: '材质/颜色/尺寸'
  },
  check: {
    hscode: '请输入正确的商品名称'
  },
  upload: {
    ta: '上传表格文件',
    tb: '将文件拖到此处，或',
    tc: '点击上传',
    td: '只能上传.xlsx/.xls文件，且不超过5MB',
    te: '上传文件只能是 .xlsx/.xls 格式!',
    tf: '上传文件大小不能超过 5MB!'
  },
  logout: {
    la: '你已被登出，可以取消继续留在该页面，或者重新登录',
    lb: '确定登出',
    lc: '重新登录',
    ld: '取消'
  },
  singleton: {
    da: '收件人信息',
    db: '快递信息',
    dc: '商品信息',
    merge: '合单',
    unmerge: '拆单',
    couriercompany: '快递公司',
    imgupload: '上传图片',
    imgadd: '添加图片',
    create: '新建',
    inven: '库存',
    type: '类型',
    shipping: '海运',
    air: '空运',
    spec: '规格'
  },
  picker: {
    start: '开始日期',
    end: '结束日期',
    to: '至',
    opa: '最近一周',
    opb: '最近一个月',
    opc: '最近三个月'
  },
  inven: {
    create: '创建库存',
    number: '库存编号'
  },
  statement: {
    date: '选择一个或多个日期',
    statement: '结算',
    total: '总计',
    expressno: '快递单号',
    outdate: '出库日期',
    customer: '客户',
    receiver: '收件人',
    bill: '账单',
    statementcount: '结算数量',
    weightsubtotal: '重量小计',
    type: '结算类型',
    costsubtotal: '费用小计',
    statementdate: '结算日期',
    statementer: '结算人',
    statementamount: '结算金额',
    unstatementbill: '未结算对账单',
    out: '导出报表'
  },
  fee: {
    baseweight: '首重',

  },
  balance: {
    all: '全部',
    in: '转入',
    out: '支出',
    time: '交易时间'
  },
  bill: {
    bcount: '结算数量',
    m: '重量小计',
    t: '结算类型',
    f: '费用小计',
    bf: '结算费用',
    d: '结算日期'
  },
  od: {
    info: '订单信息',
    invo: '物流信息',
    oper: '操作记录',
    upt: '上传时间',
    int: '入库时间',
    out: '出库时间',
    type: '运输方式',
    zh: '中国段',
    hs: '海关',
    ko: '韩国段',
    opt: '操作时间',
    opname: '操作人'
  }
}
